<ng-container
  *ngIf="
    (formattedAppointmentHistory.length || claimDetails.history) &&
      !isRemedialFlow;
    else SingleStatusSection
  "
>
  <section *ngIf="isPaymentPanelPresent">
    <span class="connector-bar"></span>
    <section class="title">
      <dgx-components-icon size="lg" name="circle-check"> </dgx-components-icon>
      <p>
        {{
          claimDetails?.paymentInformation?.amount
            | currency : 'GBP' : 'symbol' : '1.0-2'
        }}
        {{ paymentTypeLabel }} paid
      </p>
    </section>
  </section>
  <section *ngIf="fullTrackerEnabled">
    <span class="connector-bar"></span>
    <section class="title">
      <dgx-components-icon size="lg" name="circle-check"> </dgx-components-icon>
      <p>{{ 'MMR.TRACKER.BOOKED' | translate }}</p>
      <p class="visit-date" style="margin-left: auto">
        {{
          isNonEngineerOption
            ? (claimDetails?.history[0]?.date | bookedTimeDate)
            : (formattedAppointmentHistory[0]?.bookedTime ??
                formattedAppointmentHistory[0]?.date | bookedTimeDate)
        }}
      </p>
    </section>
  </section>
  <section
    *ngFor="
      let item of formattedAppointmentHistory;
      let index = index;
      let last = last
    "
    [class.active-stage]="last"
    [class]="last ? currentAppointmentStatus : ''"
  >
    <!-- Used for transition between states -->
    <span class="connector-bar" *ngIf="!last"></span>

    <ng-container
      [ngTemplateOutlet]="templateGenerated[index]"
      [ngTemplateOutletContext]="{
        last: last,
        item: item
      }"
    >
    </ng-container>

    <section
      *ngIf="
        ((claimDetails.cancelable && showCancelButton) ||
          claimDetails.rebookable ||
          claimDetails.trackable) &&
        last
      "
      class="btn-container"
      [ngClass]="!showCancelButton ? '.btn-container no-cancel-btn' : ''"
    >
      <dgx-components-button
        *ngIf="claimDetails.trackable"
        [fill]="true"
        (clicked)="trackClaim.emit()"
      >
        {{
          'MMR.TRACK_TYPE' | translate : { claimType: claimType | lowercase }
        }}</dgx-components-button
      >
      <dgx-components-button
        *ngIf="claimDetails.rebookable"
        [fill]="true"
        [variant]="true ? 'secondary' : 'primary'"
        (clicked)="rebookClaim.emit()"
        data-testid="rebook-btn"
      >
        {{ 'MMR.CHANGE_REPAIR_DATE_CTA' | translate }}</dgx-components-button
      >
      <section
        *ngIf="claimDetails.cancelable"
        class="btn-cancel devider"
        data-testid="cancel-repair-btn"
      >
        <p class="typog-body-bold">No longer need a {{ claimLabel }}?</p>
        <button (click)="cancelClaim.emit()">
          <p class="typog-body-bold link">Cancel the {{ claimLabel }}</p>
        </button>
      </section>
    </section>
  </section>

  <ng-container *ngIf="fullTrackerEnabled">
    <section *ngFor="let stage of incompleteStates" class="incomplete-stage">
      <section class="title">
        <dgx-components-icon size="lg" name="circle-dashed">
        </dgx-components-icon>
        <p>{{ 'MMR.TRACKER.' + stage | translate }}</p>
      </section>
    </section>

    <section class="incomplete-stage">
      <section class="title">
        <dgx-components-icon size="lg" name="circle-dashed">
        </dgx-components-icon>
        <p>{{ 'MMR.TRACKER.COMPLETE' | translate }}</p>
      </section>
    </section>
  </ng-container>
</ng-container>

<!-- Build templates for different states down here -->

<!-- --------------------- -->
<!-- Specific claim states -->
<!-- --------------------- -->

<ng-template #EngineerVisit let-last="last" let-item="item">
  <section class="title">
    <div *ngIf="last" class="active-icon"></div>
    <dgx-components-icon *ngIf="!last" size="lg" name="circle-check">
    </dgx-components-icon>
    <p *ngIf="item.appointmentIsToday; else Status">
      {{ 'MMR.TRACKER.COMING_TODAY' | translate }}
    </p>

    <ng-template #Status>
      <p *ngIf="claimType === 'REPAIR'">
        {{ item.appointmentCompletionStatus || currentStatus }}
      </p>
      <p *ngIf="claimType === 'SERVICE'">
        {{ 'MMR.TRACKER.STEPS.ENGINEER_VISIT' | translate }}
      </p>
    </ng-template>

    <p *ngIf="!last" class="visit-date" style="margin-left: auto">
      {{ item.appointmentDate | bookedTimeDate }}
    </p>
  </section>
  <section *ngIf="last" class="content">
    <p>
      {{
        'MMR.TRACKER.ENGINEER_VISIT.' +
          (appointmentIsToday ? 'TODAY' : 'FUTURE') +
          '.DESCRIPTION_' +
          (item.appointmentTime === 'ANY' || !item.appointmentTime
            ? 'NO_TIME'
            : item.appointmentTimeEnd
            ? 'WITH_TIME'
            : 'WITH_SINGLE_TIME')
          | translate
            : {
                date: item.appointmentDate | date : 'EEEE d MMMM yyyy',
                startTime: item.appointmentTimeStart | bookedTime,
                endTime: item.appointmentTimeEnd | bookedTime
              }
      }}
    </p>
    <p
      *ngIf="
        !appointmentIsToday &&
        (item.appointmentTime === 'ANY' ||
          item.appointmentTime === 'NO TIME' ||
          !item.appointmentTime)
      "
      class="arrival-time-message"
    >
      The {{ claimType === 'SERVICE' ? 'service provider' : 'repairer' }} will
      let you know their arrival time either on the day or the day before.
    </p>
  </section>
</ng-template>

<ng-template #AwaitingParts let-last="last" let-item="item">
  <section class="title">
    <div *ngIf="last" class="active-icon"></div>
    <dgx-components-icon *ngIf="!last" name="circle-check">
    </dgx-components-icon>
    <p>
      {{ mappedStatus || item.appointmentCompletionStatus }}
    </p>
    <p *ngIf="!last" class="visit-date" style="margin-left: auto">
      {{ item.appointmentDate | bookedTimeDate }}
    </p>
  </section>
  <section *ngIf="last" class="content">
    <p>
      {{
        'MMR.TRACKER.AWAITING_PARTS.' + (currentAppointmentStatus || 'DEFAULT')
          | translate
      }}
    </p>
  </section>
</ng-template>

<ng-template #OutcardLeft let-last="last" let-item="item">
  <section class="title">
    <div *ngIf="last" class="active-icon"></div>
    <dgx-components-icon *ngIf="!last" size="lg" name="circle-check">
    </dgx-components-icon>
    <p>
      {{ currentStatus }}
    </p>
    <p *ngIf="!last" class="visit-date" style="margin-left: auto">
      {{ item.appointmentDate | bookedTimeDate }}
    </p>
  </section>
  <section *ngIf="last">
    <p>
      {{
        'MMR.SECTION.' +
          claimType +
          '.VISIT_FAILED.CUSTOMER' +
          (isWHPAndHasMobileNumber ? '_MOBILE' : '') | translate
      }}
    </p>

    <section
      *ngIf="!isWHPAndHasMobileNumber && !isVokeraAndHasMobileNumber"
      class="call-to-rebook"
    >
      <claims-athome-myaccount-phone-number
        [phoneNumber]="claimDetails.repairer.phone_number"
        [phoneLabel]="'MMR.TRACKER.CALL_TO_REBOOK'"
      >
      </claims-athome-myaccount-phone-number>
    </section>
  </section>
</ng-template>

<ng-template #NonEngineerServiceOption let-last="last" let-item="item">
  <section class="title">
    <div *ngIf="last" class="active-icon"></div>
    <dgx-components-icon *ngIf="!last" name="circle-check">
    </dgx-components-icon>
    <p>
      {{ mappedServiceOptionType }}
    </p>
  </section>
  <section *ngIf="last" class="content next-steps" data-testid="next-steps">
    <p
      *ngIf="
        claimDetails.serviceOptionType === 'Courier' &&
        !gadgetType &&
        courierTranslationKey
      "
    >
      {{ courierTranslationKey | translate : {
        date: claimDetails.appointmentDateSelected | date : 'EEEE d MMMM yyyy',
      } }}
    </p>

    <p *ngIf="claimDetails.serviceOptionType === 'Courier' && gadgetType">
      <ng-container *ngIf="claimDetails.appointmentDateSelected">
        They'll arrive on
        {{ claimDetails.appointmentDateSelected | date : 'EEEE d MMMM yyyy' }}.
        <ng-container *ngIf="isGamesConsole; else courierConfirmation">
          You'll receive confirmation in a text, email or DPD app notification.
        </ng-container>
        <ng-template #courierConfirmation>
          You'll have received confirmation in a text, email or DPD app
          notification.
        </ng-template>
      </ng-container>

      <ng-container *ngIf="!claimDetails.appointmentDateSelected">
        <ng-container *ngIf="isGamesConsole; else courierDeliveryDate">
          You'll receive confirmation in a text, email or DPD app notification.
        </ng-container>
        <ng-template #courierDeliveryDate>
          You'll have received your delivery date in a text, email or DPD app
          notification.
        </ng-template>
      </ng-container>
    </p>
    <p
      [class.typog-body-bold]="
        claimDetails.serviceOptionType === 'Courier' ||
        (!courierTranslationKey && !gadgetType)
      "
      *ngIf="claimDetails.serviceOptionType !== 'Self Send' || !gadgetType"
    >
      {{ titleKey | translate }}
    </p>
    <p
      class="next-steps-subtitle"
      *ngIf="
        claimDetails.serviceOptionType !== 'Courier' &&
        claimDetails?.appointmentDateSelected
      "
    >
      {{ 'MMR.TRACKER.STEPS.NEXT_STEPS' | translate }}
    </p>

    <ol data-testid="next-steps-text">
      <li
        *ngFor="let step of nextStepsArray; let i = index"
        [attr.data-testid]="'step-' + i"
        [innerHtml]="step | translate"
      ></li>
    </ol>

    <p
      *ngIf="
        claimDetails.serviceOptionType === 'Courier' &&
        gadgetType &&
        claimDetails?.appointmentDateSelected
      "
    >
      <ng-container *ngIf="isGamesConsole; else exchangeInfo">
        <strong>If you chose collect and replace,</strong> your item will be
        assessed and a replacement sent to you — usually within 3 working days.
        Your replacement will be brand new or Grade A refurbished.
      </ng-container>
      <ng-template #exchangeInfo>
        <strong>If it’s an exchange,</strong> they’ll deliver the replacement
        and collect the faulty product.
      </ng-template>
    </p>
  </section>
</ng-template>

<ng-template #FallbackView let-last="last" let-item="item">
  <section class="title">
    <div *ngIf="last" class="active-icon"></div>
    <dgx-components-icon *ngIf="!last" size="lg" name="circle-check">
    </dgx-components-icon>
    <p>{{ item.appointmentCompletionStatus || currentStatus }}</p>
    <p *ngIf="!last" class="visit-date" style="margin-left: auto">
      {{ item.appointmentDate | bookedTimeDate }}
    </p>
  </section>
</ng-template>

<ng-template #GenericStateView let-last="last" let-item="item">
  <section class="title">
    <div *ngIf="last" class="active-icon"></div>
    <dgx-components-icon *ngIf="!last" size="lg" name="circle-check">
    </dgx-components-icon>
    <p>{{ mappedStatus || currentStatus }}</p>
  </section>
  <section *ngIf="last" class="content">
    <p>
      {{ 'MMR.SECTION.' + claimType + specialStatesKeys | translate }}
    </p>
  </section>
</ng-template>

<!-- Specific states (non whp), without appointment history -->
<ng-template #SingleStatusSection>
  <section
    [class.alert-state]="isRemedialWorkRequired"
    class="active-stage title"
  >
    <div class="status-section">
      <div class="active-icon"></div>
      <p>
        {{ isRemedialFlow && !isHeatingPlan ? mappedStatus : currentStatus }}
      </p>
    </div>

    <section *ngIf="singleViewContent" class="content">
      <p>
        {{ singleViewContent | translate }}
      </p>
      <claims-athome-myaccount-phone-number
        *ngIf="isRemedialFlow"
        [phoneNumber]="remedialPhoneNumber"
      >
      </claims-athome-myaccount-phone-number>
    </section>
  </section>
</ng-template>

<ng-template #SelfFit>
  <section class="active-stage title self-fit_container">
    <div class="status-section">
      <div class="active-icon"></div>
      <p>Waiting for parts</p>
    </div>

    <section class="content">
      <ol>
        <li>
          Within 24 working hours of booking, the supplier will contact you by
          WhatsApp, phone or email.
        </li>
        <li>
          They might ask for a picture of the model and serial number label.
        </li>
        <li>
          They’ll order the part and keep you updated on delivery and
          availability.
        </li>
      </ol>
    </section>
  </section>
</ng-template>
